import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { trackPromise } from 'react-promise-tracker'

import HelloIntroBox from '../../../../../components/IntroBox'
import BackToPortal from '../../../../../components/BackToPortal'
import { GetInsightsDocumentCategories } from '../../../../../store/ContentfulClient'
import LoadingWrapper from '../../../../../components/LoadingWrapper'

const InsightGraphsSidebar = () => {
    const history = useHistory()

    const InsightPromiseArea = 'insight-list'
    const InsightsSidebarPromiseArea = 'insights-sidebar'

    const [selectedCategory, setSelectedCategory] = useState('')
    const [categories, setCategories] = useState([])

    const refreshState = () => {
        if (categories.length > 0) {
            const item = categories.filter((_) => _.fields.defaultSelection === true)
            setSelectedCategory(item[0].fields.name)
        } else {
            setSelectedCategory('')
        }
    }

    useEffect(() => {
        trackPromise(
            GetInsightsDocumentCategories().then((items) => {
                setCategories(items)
                const item = items.filter((_) => _.fields.defaultSelection === true)
                if (item.length === 1) setSelectedCategory(item[0].fields.name)
            }),
            InsightPromiseArea
        )
    }, [])

    return (
        <>
            <Link to="/insights" onClick={refreshState} className="layer-header">
                <h1>Insights</h1>
            </Link>
            <HelloIntroBox type="Insights" />
            <BackToPortal />
            <div id="blog-categories">
                <LoadingWrapper area={InsightsSidebarPromiseArea}>
                    <ul>
                        {categories.map((filter) => {
                            const {
                                sys: { id },
                                fields: { name, link },
                            } = filter
                            return (
                                <li key={id}>
                                    <span
                                        onClick={() => {
                                            if (selectedCategory !== name) {
                                                setSelectedCategory(name)
                                            } else {
                                                setSelectedCategory('')
                                            }
                                            history.push('/insights' + link)
                                        }}
                                        className={name === selectedCategory ? 'active' : null}
                                    >
                                        {name}
                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                </LoadingWrapper>
            </div>
        </>
    )
}

export default InsightGraphsSidebar
